'use client';

import { c as _c } from "react/compiler-runtime";
import SvgChevronright from '@common/__generated__/icon/SvgChevronright';
import { SvgFireFill } from '@common/icon';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { Rating } from '@/app/donation/_components/Rating';
import { Image } from '@/components/client';
import { BREAKPOINTS, DONATION_ROUTES } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
interface RecentOrderGiftListItemProps {
  mainImageUrl: string;
  institution: {
    logoUrl: string;
    id: number | string;
    name: string;
  };
  productNumber: string;
  slugId: string;
  productName: string;
  reviewCount: number;
  reviewRating: number;
  createAt: string;
}
export const RecentOrderGiftListItem = t0 => {
  const $ = _c(59);
  const {
    mainImageUrl,
    institution,
    productNumber,
    slugId,
    productName,
    reviewCount,
    reviewRating,
    createAt
  } = t0;
  const isDesktop = useMediaQuery(BREAKPOINTS.DESKTOP);
  let t1;
  if ($[0] !== createAt) {
    t1 = getTimeAgo(createAt);
    $[0] = createAt;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const timeAgo = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("flex w-[22rem] items-center justify-between gap-20", "mobile-tablet:w-[20.9375rem] mobile-tablet:justify-start mobile-tablet:gap-16 mobile-tablet:pr-32");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== productNumber || $[4] !== slugId) {
    t3 = DONATION_ROUTES.GIFTS_DETAIL.pathname({
      productNumber: slugId ?? productNumber
    });
    $[3] = productNumber;
    $[4] = slugId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `${productName} 상세 페이지로 이동`;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn("size-140 rounded-xlarge", "mobile-tablet:size-104");
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== mainImageUrl || $[8] !== productName) {
    t6 = <Image src={mainImageUrl} alt={productName} width={280} height={280} sizes={`${BREAKPOINTS.MOBILE_TABLET} 104px, 140px`} className={t5} />;
    $[7] = mainImageUrl;
    $[8] = productName;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t6) {
    t7 = <CustomLink href={t3} aria-label={t4} className="relative size-fit rounded-xlarge">{t6}</CustomLink>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== institution.id) {
    t8 = DONATION_ROUTES.HOMETOWNS_DETAIL.pathname({
      id: institution.id
    });
    $[14] = institution.id;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = cn("relative size-24 overflow-hidden rounded-pill border border-Gray-300", "mobile-tablet:size-20");
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = `${institution.name} 로고 이미지`;
  let t11;
  if ($[17] !== institution.logoUrl || $[18] !== t10) {
    t11 = <div className={t9}><Image fill={true} src={institution.logoUrl} alt={t10} className="object-cover" sizes={`${BREAKPOINTS.MOBILE_TABLET} 20px, 24px`} /></div>;
    $[17] = institution.logoUrl;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = cn("font-600 text-Gray-600 transition-colors typo-body4 group-hover:text-Gray-700", "mobile-tablet:font-600 mobile-tablet:typo-caption1");
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== institution.name) {
    t13 = <p className={t12}>{institution.name}</p>;
    $[21] = institution.name;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <SvgChevronright className={cn("size-16 text-Gray-600 transition-colors group-hover:text-Gray-700", "mobile-tablet:size-12")} />;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t11 || $[25] !== t13 || $[26] !== t8) {
    t15 = <CustomLink className="group flex items-center gap-4" href={t8}>{t11}{t13}{t14}</CustomLink>;
    $[24] = t11;
    $[25] = t13;
    $[26] = t8;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== productNumber || $[29] !== slugId) {
    t16 = DONATION_ROUTES.GIFTS_DETAIL.pathname({
      productNumber: slugId ?? productNumber
    });
    $[28] = productNumber;
    $[29] = slugId;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  const t17 = `${productName} 상세 페이지로 이동`;
  let t18;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = cn("line-clamp-2 pt-2 font-500 text-Gray-800 typo-body3", "mobile-tablet:font-500 mobile-tablet:typo-body4");
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== productName || $[33] !== t16 || $[34] !== t17) {
    t19 = <CustomLink href={t16} aria-label={t17} className={t18}>{productName}</CustomLink>;
    $[32] = productName;
    $[33] = t16;
    $[34] = t17;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  const t20 = isDesktop ? 16 : 12;
  let t21;
  if ($[36] !== reviewRating || $[37] !== t20) {
    t21 = <Rating value={reviewRating} size={t20} />;
    $[36] = reviewRating;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = cn("pt-6 font-400 text-Gray-600 typo-caption1", "mobile-tablet:font-400 mobile-tablet:typo-caption2");
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== reviewCount) {
    t23 = reviewCount?.toLocaleString();
    $[40] = reviewCount;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== t23) {
    t24 = <span className={t22}>({t23})</span>;
    $[42] = t23;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] !== t21 || $[45] !== t24) {
    t25 = <div className="flex items-center gap-4">{t21}{t24}</div>;
    $[44] = t21;
    $[45] = t24;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  let t27;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <SvgFireFill className={cn("size-20 text-O-300", "mobile-tablet:size-14")} />;
    t27 = cn("whitespace-nowrap font-600 text-O-400 typo-body2", "mobile-tablet:font-600 mobile-tablet:typo-caption1");
    $[47] = t26;
    $[48] = t27;
  } else {
    t26 = $[47];
    t27 = $[48];
  }
  let t28;
  if ($[49] !== timeAgo) {
    t28 = <div className="flex items-center pt-2">{t26}<p className={t27}>{timeAgo} 전에 주문했어요!</p></div>;
    $[49] = timeAgo;
    $[50] = t28;
  } else {
    t28 = $[50];
  }
  let t29;
  if ($[51] !== t15 || $[52] !== t19 || $[53] !== t25 || $[54] !== t28) {
    t29 = <div className="flex flex-1 flex-col">{t15}{t19}{t25}{t28}</div>;
    $[51] = t15;
    $[52] = t19;
    $[53] = t25;
    $[54] = t28;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== t29 || $[57] !== t7) {
    t30 = <li className={t2}>{t7}{t29}</li>;
    $[56] = t29;
    $[57] = t7;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  return t30;
};
const getTimeAgo = (date: string) => {
  if (typeof date !== 'string') return '-';

  //* 현재 시간과 주어진 날짜를 사용자의 로컬 시간대에서 계산
  const now = new Date();
  //* 입력으로 받는 iso는 한국 시간이므로 국제 표준시(utc)로 변경하려면 offset을 붙여줘야 함
  const targetDate = new Date(date + '+09:00');

  //* 시간 차이 계산 (밀리초)
  const diff = now.getTime() - targetDate.getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  //* 음수인 경우 (미래 날짜) 처리
  if (seconds < 0) {
    return '방금';
  }
  if (seconds < 60) {
    return `${seconds}초`;
  }
  if (minutes < 60) {
    return `${minutes}분`;
  }
  return `${hours}시간`;
};